import { ThunkAction, ThunkDispatch } from 'redux-thunk'

import Client from '../Client/Client'
import { ILastMinute } from '../Client/ILastMinute'

import {
    ActionTypes,
    DELETE_LAST_MINUTE,
    DELETE_LAST_MINUTE_FAILURE,
    DELETE_LAST_MINUTE_PERMANENT,
    DELETE_LAST_MINUTE_SUCCESS,
    GET_LAST_MINUTES,
    GET_LAST_MINUTES_FAILURE,
    GET_LAST_MINUTES_SUCCESS,
    UNDO_DELETE_LAST_MINUTE,
    UNDO_DELETE_LAST_MINUTE_FAILURE,
    UNDO_DELETE_LAST_MINUTE_SUCCESS,
} from './ActionTypes'
import IState from './IState'

export const getLastMinutes = (): ThunkAction<
    any,
    IState,
    undefined,
    ActionTypes
> => {
    return (dispatch: ThunkDispatch<IState, undefined, any>) => {
        dispatch({
            type: GET_LAST_MINUTES,
        })

        return Client.getLastMinutes().then(
            (lastMinutes: ILastMinute[]) =>
                dispatch(getLastMinutesSuccess(lastMinutes)),
            () => dispatch(getLastMinutesFailure())
        )
    }
}

const getLastMinutesSuccess = (lastMinutes: ILastMinute[]): ActionTypes => {
    return {
        type: GET_LAST_MINUTES_SUCCESS,
        payload: {
            lastMinutes,
        },
    }
}

const getLastMinutesFailure = (): ActionTypes => {
    return {
        type: GET_LAST_MINUTES_FAILURE,
    }
}

export const deleteLastMinute = (
    lastMinute: ILastMinute
): ThunkAction<any, IState, undefined, ActionTypes> => {
    return (dispatch: ThunkDispatch<IState, undefined, any>) => {
        dispatch({
            type: DELETE_LAST_MINUTE,
        })

        return Client.deleteLastMinute(lastMinute).then(
            (lastMinute: ILastMinute) =>
                dispatch(deleteLastMinuteSuccess(lastMinute)),
            () => dispatch(deleteLastMinuteFailure())
        )
    }
}

const deleteLastMinuteSuccess = (lastMinute: ILastMinute): ActionTypes => {
    return {
        type: DELETE_LAST_MINUTE_SUCCESS,
        payload: {
            lastMinute,
        },
    }
}

export const deleteLastMinutePermanent = (
    lastMinute: ILastMinute
): ActionTypes => {
    return {
        type: DELETE_LAST_MINUTE_PERMANENT,
        payload: {
            lastMinute,
        },
    }
}

const deleteLastMinuteFailure = (): ActionTypes => {
    return {
        type: DELETE_LAST_MINUTE_FAILURE,
    }
}

export const undoDeleteLastMinute = (
    lastMinute: ILastMinute
): ThunkAction<any, IState, undefined, ActionTypes> => {
    return (dispatch: ThunkDispatch<IState, undefined, any>) => {
        dispatch({
            type: UNDO_DELETE_LAST_MINUTE,
        })

        return Client.restoreLastMinute(lastMinute).then(
            (lastMinute: ILastMinute) =>
                dispatch(undoDeleteLastMinuteSuccess(lastMinute)),
            () => dispatch(undoDeleteLastMinuteFailure())
        )
    }
}

const undoDeleteLastMinuteSuccess = (lastMinute: ILastMinute): ActionTypes => {
    return {
        type: UNDO_DELETE_LAST_MINUTE_SUCCESS,
        payload: {
            lastMinute,
        },
    }
}

const undoDeleteLastMinuteFailure = (): ActionTypes => {
    return {
        type: UNDO_DELETE_LAST_MINUTE_FAILURE,
    }
}
